var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.customer)?_c('span',[_c('button',{staticClass:"btn btn-sm btn-info",attrs:{"type":"button"},on:{"click":_vm.showModal}},[_vm._v(" Danh sách ")]),_c('b-modal',{ref:"my-modal",attrs:{"size":"xl","hide-footer":"","title":"Danh sách người nhận"}},[_c('div',{staticClass:"d-block text-center"},[_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"search-options":{
          enabled: true,
          trigger: 'enter',
          skipDiacritics: true,
          searchFn: _vm.mySearchFn,
          placeholder: 'Tìm kiếm theo dữ liệu nhập vào'
        },"pagination-options":{
          enabled: true,
          rowsPerPageLabel: 'các mục trong trang',
          nextLabel: 'tiếp',
          prevLabel: 'trước',
          mode: 'records',
          allLabel: 'Tất cả'
        },"line-numbers":true},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.field === '_id')?_c('span',[_c('button',{staticClass:"btn btn-outline-primary btn-sm mx-2",on:{"click":function($event){return _vm.createNewOrder(props.row)}}},[_c('i',{staticClass:"bx bx-edit-alt"}),_vm._v(" Tạo đơn mới ")])]):(props.column.field === 'crt')?_c('span',[_vm._v(" "+_vm._s(_vm.formatDate(props.row.crt))+" ")]):_vm._e()]}}],null,false,1029194957)})],1)])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }